import React from "react";
import { useParams } from "react-router-dom";

import { useMeteredUsageCapabilities } from "components/RequirePermission/useCapabilities";

import MeteredUsageDashboard from "./MeteredUsageDashboard";
import MeteredUsageUserDetail from "./MeteredUsageUserDetail";

// /admin/:orgId/metered-usage — this organization's billing usage (the org-scoped API tier).
const OrgMeteredUsage = () => {
  const { orgId } = useParams();
  return <MeteredUsageDashboard scope="org" caps={useMeteredUsageCapabilities(orgId)} />;
};

// /admin/:orgId/metered-usage/users/:userId
export const OrgMeteredUsageUser = () => {
  const { orgId } = useParams();
  return <MeteredUsageUserDetail scope="org" caps={useMeteredUsageCapabilities(orgId)} />;
};

export default OrgMeteredUsage;
